import Vue from 'vue'
import Router from 'vue-router'
import ScenarioStart from '@/components/ScenarioStart'
import AddEntity from '@/components/AddEntity'
import EditEntity from '@/components/EditEntity'
import RoundPrep from '@/components/RoundPrep'
import TurnOrder from '@/components/TurnOrder'
import LoadingRound from '@/components/LoadingRound'
import Login from '@/components/Auth/Login'
import firebase from 'firebase'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Login',
      component:  Login
    },
    {
      path: '/ScenarioStart',
      name: 'ScenarioStart',
      component: ScenarioStart,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/AddEntity',
      name: 'AddEntity',
      component: AddEntity,
      props: true,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/EditEntity',
      name: 'EditEntity',
      component:  EditEntity,
      props: true,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/RoundPrep/:name',
      name: 'RoundPrep',
      component:  RoundPrep,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/LoadingRound',
      name: 'LoadingRound',
      component: LoadingRound,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/TurnOrder/:name',
      name: 'TurnOrder',
      component:  TurnOrder,
      meta: {
        requiresAuth: true
      }
    },
  ]
})

async function getUid() {
  let user = await firebase.auth().currentUser
  return user
}

router.beforeEach((to, from, next) => {

  // check to see if route requires auth
  if (to.matched.some(rec => rec.meta.requiresAuth)){
    
    // check auth state of user
    let user = getUid().then(() => {
      console.log("router witnesses user:", user)
      if(user){

        // user signed in, proceed to route
        next()
      } else {

        // no user signed in, redirect to login
        next({ name: 'Login' })
      }
    })
    // let user = firebase.auth().currentUser
    // console.log("router witnesses user:", user)
    // if(user){

    //   // user signed in, proceed to route
    //   next()
    // } else {

    //   // no user signed in, redirect to login
    //   next({ name: 'Login' })
    // }
  } else {
    next()
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js